import editOrder from '../assets/release-2026-10-27/reihenfolge-01-bearbeiten.png'
import sorting from '../assets/release-2026-10-27/reihenfolge-02-sortieren.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Window screenshots, 2033×1162; measured on their 2000×1143 preview, which gives the same percentages. */
const box = makeBox(2000, 1143)

export const REIHENFOLGE_HANDWERKER_INTRO =
  'Die Leitung legt fest, in welcher Reihenfolge die Handwerker im Kalender stehen und wer ausgeblendet ist. Das gilt für alle, die den Kalender sehen.'

export const REIHENFOLGE_HANDWERKER_STEPS: GuideStepContent[] = [
  {
    title: 'Reihenfolge bearbeiten',
    text: 'Öffnen Sie den „Kalender“. Oben über den Handwerkern klicken Sie auf das Pfeil-Symbol „Reihenfolge bearbeiten“.',
    image: editOrder,
    imageAlt: 'Kalender der Leitung mit dem Pfeil-Symbol neben „Handwerkern“',
    focus: [box(554, 310, 592, 344)],
    wide: true,
  },
  {
    title: 'Sortieren, ausblenden, speichern',
    text: 'Ziehen Sie einen Handwerker am Griff an die gewünschte Stelle. Mit dem Augen-Symbol blenden Sie ihn aus oder wieder ein. Speichern Sie mit dem Häkchen, mit dem X brechen Sie ab.',
    note: {
      title: 'Beim Planen gilt das Gewerk',
      text: 'Wird ein Termin geplant, stehen die Handwerker nach Gewerk sortiert — dann erscheinen auch die ausgeblendeten.',
    },
    image: sorting,
    imageAlt: 'Kalender im Bearbeiten-Modus mit Griff und Augen-Symbol je Handwerker',
    focus: [box(560, 366, 590, 420), box(518, 310, 590, 344)],
    wide: true,
  },
]
